import { render, staticRenderFns } from "./RequerentePesquisa.vue?vue&type=template&id=589f2d04&"
import script from "./RequerentePesquisa.vue?vue&type=script&lang=js&"
export * from "./RequerentePesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RequerentePesquisa.vue"
export default component.exports